import * as React from 'react';
import useUnmount from '../hooks/useUnmount';
import { LooksInfusionSliderVariant } from './types';
import { EmptyLooksInfusionSlider, LooksInfusionSliderPlaceholder } from './LooksInfusionSlider';
import { Experiment } from 'Client/components/Generic/ABTestExperiment';
import { resetLooksInfusionSliderViewAction } from 'Client/redux/productLooks/action';
import { useBellaDispatch } from 'Client/redux/hooks';

interface LooksInfusionSliderExperimentProps {
    variant: LooksInfusionSliderVariant;
}

const LooksInfusionSliderExperiment = ({ variant }: LooksInfusionSliderExperimentProps) => {
    const dispatch = useBellaDispatch();

    useUnmount(() => dispatch(resetLooksInfusionSliderViewAction()));

    return (
        <Experiment activeVariant={variant} name="Looks Infusion Slider">
            <Experiment.Variant name="none">
                <EmptyLooksInfusionSlider />
            </Experiment.Variant>
            <Experiment.Variant name={['top', 'bottom']}>
                <LooksInfusionSliderPlaceholder variant={variant} />
            </Experiment.Variant>
        </Experiment>
    );
};

export default React.memo(LooksInfusionSliderExperiment);
